import { useEffect } from 'react';
import { ifDevMessage } from './devMessage';

export const deprecatedComponentMessage = ({
  componentName,
  date,
  upgradeURL
}) => {
  ifDevMessage(
    `[DEPRECATION] <${componentName} />\n` +
      `Carina <${componentName} /> is deprecated and will be removed at the end of ${date}! ` +
      'Check out the link below for upgrade guidance. \n' +
      upgradeURL
  );
};

export const deprecatedPropValueMessage = ({
  componentName,
  propName,
  propValue,
  date,
  upgradeURL
}) => {
  ifDevMessage(
    `[PROP VALUE DEPRECATION]: <${componentName} ${propName}='${propValue}' />\n` +
      `Value '${propValue}' for property '${propName}' is deprecated and will be removed at the end of ${date}! ` +
      'Check out the link below for upgrade guidance.\n' +
      upgradeURL
  );
};

export const useDeprecatedComponentMessage = messageOptions => {
  useEffect(() => {
    deprecatedComponentMessage(messageOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // only render once
};
